import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgImport = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3 6.5L7.64645 11.1464C7.84171 11.3417 8.15829 11.3417 8.35355 11.1464L13 6.5M14 14.5H2M8 0.999985V11",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinejoin: "round"
	})
});
export default SvgImport;
